import { useEffect, useState } from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Loading from "./Loading";

export default function HistoricoPagammento() {
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  async function mostrarRecibos() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const dadosRecibo = await axios.get(
        "https://api-eyazs-production-8f74.up.railway.app/recibos",
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'         // Define o tipo de conteúdo como JSON
          }
        }
      );      
      if (dadosRecibo) {
        setRecibos(dadosRecibo.data);
      }
      setLoading(false);
    } catch (erro) {
      console.log(erro);
    }
  }

  useEffect(() => {
    mostrarRecibos();
    console.log(recibos);
  }, []);

  return (
    <div className="flex flex-col justify-between min-h-screen">
      <div className="bg-blue-500 sticky top-0 z-10">
        <NavBar />
      </div>

      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div className="z-0">
          {/* Botão Voltar */}
          <button
            className="group my-4 ml-4 md:flex lg:hidden"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex items-center">
              <ChevronLeft className="group-hover:font-semibold" />
              <span className="text-sm ml-1 group-hover:font-semibold">
                Voltar
              </span>
            </div>
          </button>

          {/* Conteúdo Principal */}
          <div className="w-[95%] md:w-[90%] lg:w-[1000px] border rounded-xl h-auto mx-auto m-4 md:my-12 mt-0 overflow-x-auto">
            <div className="flex justify-center m-4 flex-col">
              <h2 className="mb-4 text-lg md:text-xl lg:text-2xl text-gray-600 text-center">
                Histórico de Pagamento
              </h2>
              <table className="min-w-full border border-gray-50">
                <thead>
                  <tr className="bg-gray-100 text-gray-500">
                    <th className="border text-center py-2 px-2 text-xs md:text-sm">
                      ID
                    </th>
                    <th className="border text-center py-2 px-2 text-xs md:text-sm">
                      Data
                    </th>
                    <th className="border text-center py-2 px-2 text-xs md:text-sm">
                      Método de Pagamento
                    </th>
                    <th className="border text-center py-2 px-2 text-xs md:text-sm">
                      Montante
                    </th>
                    <th className="border text-center py-2 px-2 text-xs md:text-sm">
                      Recibo
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-500">
                  {recibos.map((recibo, i) => {
                    const dataTransacao = new Date(recibo.dataTransacao);
                    const dia = String(dataTransacao.getDate()).padStart(
                      2,
                      "0"
                    );
                    const mes = String(dataTransacao.getMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    const ano = dataTransacao.getFullYear();
                    const dataFormatada = `${dia}/${mes}/${ano}`;
                    return (
                      <tr key={i} className="border text-xs md:text-sm">
                        <td className="text-center border py-2 px-2">
                          {i + 1}
                        </td>
                        <td className="text-center border py-2 px-2">
                          {dataFormatada}
                        </td>
                        <td className="text-center border py-2 px-2">
                          {recibo.meioPagamento}
                        </td>
                        <td className="text-center border py-2 px-2">
                          {recibo.valor}
                        </td>
                        <td className="border py-2 px-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="size-6 mx-auto cursor-pointer hover:text-blue-500 transition"
                            onClick={() => {
                              navigate(`/recibo/${recibo.idRecibo}`);
                            }}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                            />
                          </svg>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <div className="bg-blue-500">
        <Footer />
      </div>
    </div>
  );
}
